<!-- 公司业绩 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_case.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="公司业绩" en="CORPORATE PERFORMANCE"></sub-title>
        <div class="form">
          <el-input v-model="queryParams.title" placeholder="案例名称">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="onSearch"
            ></el-button>
          </el-input>
        </div>
        <div class="list" v-if="list.length != 0">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="getDetail(item)"
          >
            <div class="title">{{ item.title }}</div>
            <img :src="URL + item.newsImageUrl" alt="" class="post" />
            <div class="desc">{{ item.description }}</div>
          </div>
          <div class="full">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="queryParams.pageIndex"
              :page-size="queryParams.pageSize"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <el-empty description="暂无案例" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        title: "",
        newsCode: "866300f6ee6d4a7ab0535789a2524f33",
      },
      list: [],
      total: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.getList();
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    onSearch() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getCaseList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    getDetail(item) {
      window.scrollTo({ top: 200 });
      this.$router.push("/case/performance/performanceDetail/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .form {
      width: 300px;
      margin-left: auto;
    }
    .list {
      margin-top: 50px;
      display: flex;
      flex-wrap: wrap;

      .item {
        width: 320px;
        margin-bottom: 30px;
        padding: 20px 18px;
        box-sizing: border-box;
        border: 1px solid #bab9b9;
        cursor: pointer;
        transition: 0.5s;

        &:not(:nth-child(3n + 1)) {
          margin-left: 120px;
        }
        &:hover {
          transform: translateY(-15px);
          box-shadow: 0 0 10px #999;
        }

        .title {
          color: $theme;
          font-size: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .post {
          width: 100%;
          height: 200px;
          margin: 20px 0;
        }
        .desc {
          font-size: 15px;
          color: #5e5d5d;
          line-height: 30px;
          text-indent: 2em;
        }
      }
      .full {
        width: 100%;
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .form {
        width: 80%;
        margin-left: 0;
        margin-top: 20px;
      }
      .list {
        margin-top: 20px;

        .item {
          width: 100%;
          padding: 10px;
          margin-bottom: 10px;

          &:not(:nth-child(3n + 1)) {
            margin-left: 0;
          }
          .post {
            margin: 10px 0;
          }
          .desc {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
